<template lang="pug">
v-list-item-title(class="text-overline")
  span {{ `${startDate} - ${endDate}` }}
v-list-item-subtitle
  span {{ description }}
</template>

<script setup>
defineOptions({
  name: 'PersonInformtionListItem',
})

const props = defineProps({
  startDate: {
    type: String,
    required: true,
  },
  endDate: {
    type: String,
    default: 'PRESENT',
  },
  description: {
    type: String,
    required: true,
  },
})
</script>
